define('views/pages/basket/index',['require','views/base/page','views/pages/basket/basket-collection','text!templates/pages/basket/index.ejs'],function(require) {
    'use strict';

    var PageView = require('views/base/page'),
        BasketCollectionView = require('views/pages/basket/basket-collection'),
        template = require('text!templates/pages/basket/index.ejs');

    var BasketPageView = PageView.extend({
        autoRender: true,
        template: template,
        id: 'pages-basket-page',
        listen: {
            'addedToDOM': 'onAddedToDOM',
            'resize model': 'onResize'
        },
        windowResize: true,
        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);
            this.subscribeEvent('updateBasket', this.onUpdateBasket);
            this.subscribeEvent('removeFromBasket', this.onRemoveFromBasket);
        },
        onAddedToDOM: function() {
            this.model.trigger('resize');
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('basket-collection', new BasketCollectionView({ collection: this.model.items, model: this.model, container: this.el }));
        },
        onRemoveFromBasket: function(itemT){
            var findTrade = this.model.items.findWhere({
                tradeId: itemT.idTrade
            });

            if(findTrade){
                var find = findTrade.items.findWhere({
                    id: itemT.basketId
                });
                if(find){
                    findTrade.items.remove(find);
                }
            }
        },
        onUpdateBasket: function(itemT){
            var findTrade = this.model.items.findWhere({
                tradeId: itemT.idTrade
            });

            if(findTrade){
                var find = findTrade.items.findWhere({
                    id: itemT.basketId
                });
                if(find){
                    find.set('comment', itemT.comment);
                    find.set('amount', itemT.amount);
                }
            }
        },
        dispose: function() {
            if (this.disposed) { return; }

            PageView.prototype.dispose.apply(this, arguments);
        },
        onResize: function() {
            // var h = $('body').height();
            // var t = this.$el.position().top;
            // this.$el.height(h - t - 20);

            // this.model.notifies.trigger('resize');
        }
    });

    return BasketPageView;
});

